module.exports = __webpack_public_path__ + "static/media/thumb2.1e071e74.png";